import { rem } from 'polished';
import styled, { css } from 'styled-components';

import { ISpacerProps } from './Spacer.types';

const ResetList = css`
  > li {
    list-style: none;
  }
`;

export const StyledWrapper = styled.div<ISpacerProps>`
  position: relative;
  margin: 0 0 ${({ theme, space }) => rem(theme.spacings[`${space}`])} 0;
  padding: 0;
  border: none;

  ${({ as }) => (as === 'ol' || as === 'ul') && ResetList}
`;
